import {FunctionComponent, useEffect} from "react";
import "./index.scss";
import {ContainerBox} from "../../../components/container-box";
// @ts-ignore
import PlugAndSocket from "./plug-and-socket.svg";
import {AppSideBarPageActions, SideBarOptions} from "../../../parts/AppSideBar/model";
import {useDispatch} from "react-redux";

export const InformationAssetsUnderConstruction: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AppSideBarPageActions.updateSelectedSideBar(SideBarOptions.INFORMATION_ASSETS));
  }, []);

  return (
    <ContainerBox>
      <div className={"circle"}>
        <img src={PlugAndSocket} alt={"plug-and-socket"}/>
        <div className={"text-1"}>This Page is under construction</div>
        <div className={"info"}>
          <div className={"text-2"} style={{marginTop: "32px"}}>We are preparing to serve you better</div>
          <div className={"text-3"} style={{marginTop: "105px"}}>For more details, please contact us here</div>
          <a href="mailto:neoauthz-support@thoughtworks.com" style={{marginTop: "20px"}}>neoauthz-support@thoughtworks.com</a>
        </div>
      </div>
    </ContainerBox>
  );
}
